const numberRegex = /(?<number>[0-9.]+)(,(?<decimal>[0-9]+))?/

export type Price = number;

/**
 * Parses the price of a string input of "20.000,21" or "20000,21"
 * where . signifies thousands and ',' signifies decimal numbers
 *
 * If the input is falsy, then returns 0
 */
export function parsePrice(input: string): Price {
  input = input.trim();

  if (!input) return 0;

  const match = input.match(numberRegex);

  if (!match || !match.groups || match.length <= 1) return 0;

  const n = match.groups["number"].replace(/\./g, "");
  const d = match.groups["decimal"] ? match.groups["decimal"] : "00";

  input = `${n}.${d}`;

  return parseFloat(parseFloat(input).toFixed(2));
}

const f = Intl.NumberFormat("da-DK");

export function formatPrice(input: Price): string {
  return f.format(input);
}
